interface Props {
	img: string;
	title: string;
	text: string;
	accent: boolean;
	orderLink: string;
	moreLink: string;
	alt: string;
	/** Fill the whole panel (for photos that carry their own grey studio background). */
	fill?: boolean;
}

export default function Product(props: Props) {
	return (
		<article className="eo-product">
			<div className="eo-product__panel">
				<img className={`eo-product__image${props.fill ? " eo-product__image--fill" : ""}`} src={props.img} alt={props.alt} loading="lazy" />
			</div>
			<img className="eo-product__logo" src={props.title} alt="" />
			<p className="eo-product__text">{props.text}</p>
			<div className="eo-product__actions">
				<a className={`eo-button ${props.accent ? "eo-button--accent" : ""}`} href={props.orderLink}>
					Order
				</a>
				<a className="eo-button eo-button--outline" href={props.moreLink}>
					More info
				</a>
			</div>
		</article>
	);
}
